import React from 'react';
import { useDispatch } from 'react-redux';
import { useEffectOnce } from 'react-use';
import { Header } from './components/Header/Header';
import { Chart } from './components/Chart/Chart';
import { Wrapper } from '../../../../../../CommonComponents/OPL/Wrapper/Wrapper';
import { MarginProps } from '../../../../../../theme/styledProps';
import { OPL_MONTE_CARLO_ACTIVE } from '../../../../../../WhatIfs/WhatIfsActions';
import { Legend } from './components/Legend/Legend';
import { PDFTitle } from '../../../../../../PDFRenderer/components/PDFTitle/PDFTitle';

interface Props extends MarginProps {
  isPrint?: boolean;
  title?: string;
}

export const MonteCarlo: React.FC<Props> = ({ isPrint, title, ...rest }) => {
  const dispatch = useDispatch();

  /**
   * Legacy what ifs aware of OPL Goal
   */
  useEffectOnce(() => {
    dispatch({
      type: OPL_MONTE_CARLO_ACTIVE,
      payload: true,
    });

    return () => {
      dispatch({
        type: OPL_MONTE_CARLO_ACTIVE,
        payload: false,
      });
    };
  });

  return (
    <Wrapper {...rest}>
      <PDFTitle title={title} />

      <Header />

      <Chart mt="8" isPrint={isPrint} />

      <Legend isPrint={isPrint} />
    </Wrapper>
  );
};
